import React from 'react';

interface AppLogoProps {
  src?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

export default function AppLogo({
  size = 36,
  className = '',
  onClick,
}: AppLogoProps) {
  return (
    <div
      onClick={onClick}
      className={`flex items-center justify-center flex-shrink-0 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      style={{ width: size, height: size }}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
      aria-label="VoiceLink AI logo"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="logo-grad" x1="0" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor="#4f46e5" />
            <stop offset="100%" stopColor="#818cf8" />
          </linearGradient>
          <linearGradient id="accent-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#10b981" />
            <stop offset="100%" stopColor="#34d399" />
          </linearGradient>
        </defs>
        {/* Waveform bars */}
        <rect x="6" y="22" width="5" height="10" rx="2.5" fill="url(#logo-grad)" opacity="0.7" />
        <rect x="13" y="16" width="5" height="16" rx="2.5" fill="url(#logo-grad)" opacity="0.85" />
        {/* Center bar with mic capsule */}
        <rect x="20" y="12" width="5" height="20" rx="2.5" fill="url(#logo-grad)" />
        <rect x="27" y="16" width="5" height="16" rx="2.5" fill="url(#logo-grad)" opacity="0.85" />
        {/* Accent arc */}
        <path
          d="M 26 8 Q 35 5 36 14"
          stroke="url(#accent-grad)"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
        {/* Mic capsule top on center bar */}
        <ellipse cx="22.5" cy="10" rx="3.5" ry="4" fill="url(#logo-grad)" />
      </svg>
    </div>
  );
}